import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill"
import en from "emoji-picker-element/i18n/en"
import de from "emoji-picker-element/i18n/de"
import da from "@/locales/emoji-picker-da"
import "emoji-picker-element"
import { Picker } from "emoji-picker-element"
import Localization from "@/managers/session/localization"

polyfillCountryFlagEmojis()

const styleElement = document.createElement("style")
styleElement.textContent = `emoji-picker {
 --emoji-font-family: "Twemoji Country Flags", "Twemoji Mozilla", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Proxima Nova", sans-serif;
 --border-radius: 0.1rem;
 --border-border-radius: 0.2rem;
 --skintone-border-radius: 0.2rem;
 --indicator-color: #2172fe;
 }`
document.head.appendChild(styleElement)

export function createEmojiPicker(): Picker {
	const locale = Localization.current
	let i18n = en
	let dataSource = "https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/en/emojibase/data.json"

	switch (locale) {
		case "da":
			i18n = da
			dataSource = "https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/da/cldr-native/data.json"
			break
		case "de":
			i18n = de
			dataSource = "https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/de/cldr-native/data.json"
			break
	}

	const picker = new Picker({locale: Localization.current, i18n, dataSource})

	picker.dataset.touchScroll = "true" // enable touch scroll of Pintura child element on iOS
	picker.classList.add("light")

	return picker
}

export function isFlagEmoji(value: string): boolean {
	if (!value)
		return false

	const codePoints = [...value].map(code => code.codePointAt(0)!)
	if (codePoints.length !== 2)
		return false

	return codePoints.every(code => code >= 127462 && code <= 127487)
}

export {type Picker}
